import React from "react";
import { Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    fontFamily: "Roboto, SF-Pro-Text-Regular !important",
    fontSize: "13px !important",
  },
  // arrow: {
  //   // color: theme.palette.common.black,
  // },
}))(Tooltip);

export default StyledTooltip;
